import { BlockVisual } from '@components/ArtBoard/Block'
import { Name } from '@components/ArtBoard/Block/Name'
import { Note } from '@components/ArtBoard/Block/Note'
import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import * as ActionTypes from '@storeOld/actions'
import cx from 'classnames'
import type React from 'react'
import { useRef } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { toLightThemeColor } from '@/utils'
import lightOrDark from '@/utils/color/lightOrDark'
import css from './Block.module.scss'

type Props = {
  id: string
  isOverlay?: boolean
  isLast?: boolean
  blockId?: ID
}

export const Block: React.FC<Props> = ({
  id,
  isOverlay = false,
  isLast = false,
  blockId,
}) => {
  const dispatch = useDispatch()
  const ref = useRef(null)

  const block = useSelector(
    migrationProjectSelector.getProjectBlockOrSymbolData(id),
    shallowEqual
  )

  const { title: name, colorId, completed: isCompleted, visual } = block

  const colorHex = useSelector(
    migrationProjectSelector.getProjectColorForUI(colorId)
  )
  const theme = useSelector(migrationProjectSelector.getProjectTheme)
  const variableColor = toLightThemeColor(colorHex, theme)

  const onClick = () => {
    dispatch({
      type: ActionTypes.OPEN_BLOCK,
      payload: { id, scrolless: true },
    })
  }

  const blockStyles = {
    '--block-color': variableColor,
  } as React.CSSProperties

  return (
    <div
      ref={ref}
      className={cx(css.container, 'block', {
        [css.completed]: isCompleted,
        [css.light]: lightOrDark(variableColor) === 'dark',
        [css.dark]: lightOrDark(variableColor) === 'light',
        [css.overlay]: isOverlay,
        [css.last]: isLast,
        [css.empty]: visual.type === 'image' && !name,
        [css.opacity]: blockId !== undefined && blockId !== id,
      })}
      style={blockStyles}
      onClick={onClick}
    >
      <Name blockId={id} completed={isCompleted} />

      <BlockVisual
        imageClass={css.image}
        blockId={id}
        completed={isCompleted}
        editable={false}
      />

      <Note blockId={id} completed={isCompleted} />
    </div>
  )
}
